import { ArrowUpRight } from "lucide-react";
import { clientSites } from "@/data/homepageData";

function ClientCard({ item }) {
  return (
    <article className="rz-client-card">
      <div className="rz-client-card__image-wrap">
        <img src={item.image} alt={item.category} className="rz-client-card__image" />
      </div>

      <div className="rz-client-card__body">
        <div>
          <p className="rz-client-card__label">{item.category}</p>
          <h3>{item.title}</h3>
          <p>{item.text}</p>
        </div>

        <a
          href={item.demoUrl}
          target="_blank"
          rel="noreferrer"
          className="rz-client-card__link"
        >
          Vezi site-ul
          <ArrowUpRight size={16} />
        </a>
      </div>
    </article>
  );
}

export default function ClientSitesSection() {
  const loopedSites = [...clientSites, ...clientSites];

  return (
    <section className="rz-section" id="clienti">
      <div className="rz-shell rz-clients__heading">
        <div className="rz-section-heading rz-section-heading--split">
          <div>
            <p className="rz-kicker rz-kicker--dark">Proiecte & referințe</p>
            <h2>Exemple de prezentare construite într-o direcție clară, modernă și ușor de parcurs.</h2>
          </div>
          <p>
            Mai jos poți vedea câteva exemple de site-uri și direcții vizuale. Pentru fiecare business, structura poate fi adaptată astfel încât informațiile importante și formularul de contact să fie mai ușor de găsit.
          </p>
        </div>
      </div>

      <div className="rz-clients__viewport">
        <div className="rz-clients__track">
          {loopedSites.map((item, index) => (
            <ClientCard key={`${item.category}-${index}`} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}
